import React, { Component } from 'react'
import '../Styles/Header.css';

export default class Header extends Component {
    render() {
        return (
            <div className="header">
                MAPPING WORLD RELIGIONS
                <div className='save'></div>
            </div>  
        )
    }
}
